import { PostPromotion } from "./postPromotion.model";
import { PromotionItem } from "./promotionItem.model";
import { User } from "./user.model";

export interface IPromotion {
  id?: number;
  promotionItem?: PromotionItem[];
  postPromotions?: PostPromotion[];
  name?: string;
  type?: string;
  status?: boolean;
  description?: string;
  createdAt?: Date;
  author?: User;
  startDate?: Date;
  endDate?: Date;
  codePromo?: string;
  publicPromotionVisibility?: boolean
  isApplyToAll?: boolean
  maximumNumberOfPurchases?: number
}

export class Promotion implements IPromotion {
  constructor(
    public id?: number,
    public promotionItem?: PromotionItem[],
    public postPromotions?: PostPromotion[],
    public name?: string,
    public type?: string,
    public status?: boolean,
    public description?: string,
    public createdAt?: Date,
    public author?: User,
    public startDate?: Date,
    public endDate?: Date,
    public codePromo?: string,
    public publicPromotionVisibility?: boolean,
    public isApplyToAll?: boolean,
    public maximumNumberOfPurchases?: number

  ) {
    this.id = id;
    this.promotionItem = promotionItem;
    this.postPromotions = postPromotions;
    this.name = name;
    this.type = type;
    this.status = status;
    this.description = description;
    this.createdAt = createdAt;
    this.author = author;
    this.startDate = startDate;
    this.endDate = endDate;
    this.codePromo = codePromo;
    this.publicPromotionVisibility = publicPromotionVisibility
    this.isApplyToAll = isApplyToAll
    this.maximumNumberOfPurchases = maximumNumberOfPurchases
  }
}
